/**
 * wirePingHud — Ping / alert stub → HUD + __debugPing (SPY-214).
 */

import { PingSystem } from '../../domain/pingSystem.js';

const PING_LABELS = Object.freeze({
  danger: 'DANGER',
  on_my_way: 'ON MY WAY',
  assist: 'ASSIST',
  missing: 'MISSING'
});

function labelFor(type) {
  return PING_LABELS[type] || String(type || 'PING').toUpperCase();
}

/**
 * @param {{
 *   documentRef?: { getElementById?: Function },
 *   globalObj?: object|null,
 *   pingSystem?: import('../../domain/pingSystem.js').PingSystem
 * }} [opts]
 */
export function wirePingHud({
  documentRef = globalThis.document,
  globalObj = typeof window !== 'undefined' ? window : null,
  pingSystem = new PingSystem()
} = {}) {
  const alertEl = documentRef?.getElementById?.('ping-hud-alert') || null;

  function syncHud() {
    if (!alertEl) return;
    const latest = pingSystem.activePings[pingSystem.activePings.length - 1];
    if (!latest) {
      alertEl.hidden = true;
      alertEl.textContent = '';
      if (alertEl.style) alertEl.style.display = 'none';
      return;
    }
    alertEl.hidden = false;
    if (alertEl.style) alertEl.style.display = 'block';
    alertEl.className = `ping-hud-alert ping-hud-alert--${latest.type}`;
    alertEl.textContent =
      `${labelFor(latest.type)} @ (${Math.round(latest.x)}, ${Math.round(latest.z)})`;
  }

  function emit(type = 'danger', x = 0, z = 0, source = 'player', duration = 3) {
    const ping = pingSystem.createPing(type, x, z, source, duration);
    syncHud();
    return ping;
  }

  function tick(dt) {
    pingSystem.update(dt);
    syncHud();
  }

  function list() {
    return pingSystem.activePings.slice();
  }

  if (globalObj) {
    globalObj.__debugPing = { emit, tick, list, syncHud };
  }

  return {
    pingSystem,
    emit,
    tick,
    list,
    syncHud,
    debugApi: globalObj?.__debugPing || null
  };
}
